export const menuData = [
  {
    id: 1,
    title: 'Home',
    path: '/',
    submenu: []
  },
  {
    id: 2,
    title: 'Courses',
    path: '/courses',
    submenu: [
      {
        title: 'Qaida Courses',
        path: '/courses#qaida',
        submenu: [
          { title: 'Noorani Qaida Course', path: '/courses/noorani-qaida-course' },
          { title: 'Madani Qaida Course', path: '/courses/madani-qaida-course' },
          { title: 'Baghdadi Qaida Course', path: '/courses/baghdadi-qaida-course' },
          { title: 'Rehmani Qaida Course', path: '/courses/rehmani-qaida-course' }
        ]
      },
      {
        title: 'Quran Reading Course',
        path: '/courses#quran-reading',
        submenu: [
          { title: 'Nazra Quran Course', path: '/courses/nazra-quran-course' },
          { title: 'Quran Memorization Course', path: '/courses/quran-memorization-course' },
          { title: 'Quran Reading Course', path: '/courses/quran-reading-course' }
        ]
      },
      {
        title: 'Quran Recitation Course',
        path: '/courses#quran-recitation',
        submenu: [
          { title: 'Quran Recitation Course', path: '/courses/quran-recitation-course' },
          { title: 'Ten Qiraat Course', path: '/courses/ten-qirat-course' },
          { title: 'Quran Ijazah Course', path: '/courses/ijazah-course' },
          { title: 'Tajweed Course', path: '/courses/tajweed-course' }
        ]
      },
      {
        title: 'Quran Translation Course',
        path: '/courses#quran-translation',
        submenu: [
          { title: 'Tafseer Course', path: '/courses/tafseer-course' },
          { title: 'Quran Translation Course', path: '/courses/quran-translation-course' }
        ]
      },
      {
        title: 'Islamic Studies Course',
        path: '/courses#islamic-studies',
        submenu: [
          { title: 'Fundamentals Of Islam Course', path: '/courses/fundamentals-of-islam-course' },
          { title: 'Islamic Studies Course', path: '/courses/islamic-studies-course' },
          { title: 'Namaz Course', path: '/courses/namaz-course' },
          { title: '6 Kalma Course', path: '/courses/6-kalma-course' },
          { title: 'Janaza Course', path: '/courses/janaza-course' }
        ]
      },
      { title: 'Hadith Course', path: '/courses/hadith-course' },
      {
        title: 'Arabic Speaking Course',
        path: '/courses#arabic-speaking',
        submenu: [
          { title: 'Arabic Language Course', path: '/courses/arabic-language-course' },
          { title: 'Arabic Grammar Course', path: '/courses/arabic-grammar-course' }
        ]
      },
      { title: 'Explore All Courses', path: '/courses' }
    ]
  },
  {
    id: 3,
    title: 'Become A Teacher',
    path: '/become-a-teacher',
    submenu: []
  },
  {
    id: 4,
    title: 'Fee',
    path: '#',
    submenu: [
      { title: 'Fee Plans', path: '/study-plans-fees' },
      { title: 'Payment Options', path: '/payment-options' }
    ]
  },
  {
    id: 5,
    title: 'Teachers',
    path: '#',
    submenu: [
      { title: 'Our Teachers', path: '/our-teachers' }
    ]
  },
  {
    id: 6,
    title: 'Contact',
    path: '#',
    submenu: [
      { title: 'Contact Us', path: '/contact-us' },
      { title: 'About Us', path: '/about-us' }
    ]
  },
  {
    id: 7,
    title: 'Free Trial',
    path: '/free-trial',
    submenu: []
  },
  {
    id: 8,
    title: 'Blog',
    path: '/blog',
    submenu: []
  }
];
